<form class="form-group" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="close-container">
    <mat-icon class="close-icon" (click)="closeDialog()"></mat-icon>
  </div>
  <div class="title title--md dialog" mat-dialog-title>Resident Search</div>
  <mat-dialog-content>
    <div class="smallerText">Let's check to see if the resident is already in our records.
      Please fill in the following information and click search to look them up.</div>
      <div class="smallerText text-info">* = Required Field</div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">First Name</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{firstNameControl}}" type="text" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">Last Name*</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{lastNameControl}}" required type="text" />
        <div class="required-text" *ngIf="invalidRequiredField(lastNameControl)">
          Last Name is required
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">Primary Email</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{primaryEmailControl}}" type="text" />
      </div>
    </div>
    <div class="row">
    <div class="col-12">
      <div class="title title--xs">Additional Email</div>
      <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{additionalEmailControl}}" type="text" />
    </div>
  </div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">NPI</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{npiControl}}" type="text" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">Date of Birth</div>
          <div class="dateContainer">
            <div class="date--form-control" (click)="dateOfBirthDatePicker.open()">
              <input class="form-control-sm w-100" [disabled]="!editPrivileges" [matDatepicker]="dateOfBirthDatePicker" formControlName="{{dateOfBirthControl}}" type="text" />
              <!-- <mat-datepicker-toggle matSuffix [for]="dateOfBirthDatePicker"></mat-datepicker-toggle> -->
              <mat-datepicker disabled="false" #dateOfBirthDatePicker></mat-datepicker>
            </div>
          </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">Business Phone</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{businessPhoneControl}}" type="text" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">Home Phone</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{homePhoneControl}}" type="text" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">City</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{cityControl}}" type="text" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">State/Province</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{stateProvControl}}" type="text" />
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class=" dialog-btn-container">
      <button (click)="closeDialog()" class="btn btn--outline" type="button" >Cancel</button>
      <button class=" btn btn--solid btn--red" type="submit" [disabled]="canAddResident()">Search</button>
    </div>
  </mat-dialog-actions>

</form>
<aaos-spinner [isLoading]="loading"></aaos-spinner>

